import styled, { css } from 'styled-components';
import type { ButtonProps } from '@simplywallst/ui-core';
import { buttonCSS } from '@simplywallst/ui-core';
import { lighten } from '@simplywallst/ui-core';

export interface Props extends ButtonProps {
  styleTypeOverride?: 'add' | 'added';
}

const backgroundColor = css<Props>`
  background-color: ${({ theme, styleTypeOverride }) => {
    if (styleTypeOverride === 'added') {
      return theme.color.good;
    }
    return theme.color.brand01;
  }};
`;

const hover = css<Props>`
  background-color: ${({ theme, styleTypeOverride }) => {
    if (styleTypeOverride === 'added') {
      return `rgb(${lighten(theme.color.good, 0.1)})`;
    }
    return `rgb(${lighten(theme.color.brand01, 0.1)})`;
  }};
`;

const active = css<Props>`
  background-color: ${({ theme, styleTypeOverride }) => {
    if (styleTypeOverride === 'added') {
      return `rgb(${lighten(theme.color.good, 0.2)})`;
    }
    return `rgb(${lighten(theme.color.brand01, 0.2)})`;
  }};
`;

const svg = css<Props>`
  ${({ theme }) => css`
    > svg {
      fill: ${theme.color.white};
      opacity: 1;
    }
  `}
`;

const disabled = css<Props>`
  opacity: 1;
  background-color: ${({ theme, styleTypeOverride }) => {
    if (styleTypeOverride === 'added') {
      return theme.color.good;
    }
    return 'transparent';
  }};
`;

const addButtonCSS = css<Props>`
  ${buttonCSS} /* Overrides */
  ${backgroundColor}
  &:hover {
    ${hover}
  }
  &:active {
    ${active}
  }
  &:disabled {
    ${disabled}
  }
  ${svg}
`;

const AddButton = styled('button').attrs<Props>(({ theme }) => {
  //  ✨ Black magic focus ✨
  //  We do this so that we can distinguish between mouse focus and keyboard focus using a .using-mouse class on the body
  //  A non styled-components solution due to scoping
  return theme.focus('dashed');
})<Props>`
  ${addButtonCSS}
`;

export default AddButton;
